import VimeoPlayer from '@vimeo/player';

export default class Modal {
    constructor(elm) {

        if (!elm.dataset.modalId) { return; }

        const opener = document.querySelectorAll('[data-modal-opens=' + elm.dataset.modalId + ']');

        if (!opener) { return; }

        const iframe = elm.querySelector('iframe');
        const videoPlayer = elm.dataset.videoplayer;
        let vimeoPlayer = null;

        if (elm.dataset.videoPlayer === 'vimeo') {
            if (iframe) {
                vimeoPlayer = new VimeoPlayer(iframe);
            }
        }

        opener.forEach(x => x.addEventListener('click', function () { toggleModal(elm); }));
        elm.addEventListener('click', function (e)
        {
            e.preventDefault();
            if (!e.target.closest('video, iframe'))
            {
                toggleModal(elm);
            }
        });

        document.onkeydown = function (evt)
        {
            evt = evt || window.event;
            if (evt.keyCode === 27)
            {
                toggleModal(elm);
            }
        };

        var toggleModal = function (modal)
        {
            var video1 = modal.querySelector('.modal--active .media-with-video__video');

            if (modal.classList.contains('modal--active'))
            {
                // Closing
                modal.classList.remove('modal--active');

                // Stopping & resetting video if any
                if (iframe)
                {

                    if (iframe.src.indexOf('?autoplay=1') > -1)
                    {
                        iframe.src = iframe.src.replace('?autoplay=1', '');
                    }
                    else
                    {
                        iframe.src = iframe.src.replace('&autoplay=1', '');
                    }
                }
                if (video1)
                {
                    video1.pause();
                    video1.currentTime = 0;
                }
            }
            else
            {
                // Opening
                modal.classList.add('modal--active');

                // Playing video if any
                if (iframe)
                {
                    document.resetUrl = iframe.src;
                    if (iframe.src.indexOf('?autoplay=1') === -1 && iframe.src.indexOf('&autoplay=1') === -1)
                    {
                        if (iframe.src.indexOf('?') > -1)
                        {
                            iframe.src += '&autoplay=1';

                        } else
                        {
                            iframe.src += '?autoplay=1';

                        }
                    }
                    else
                    {
                        iframe.src = iframe.src;
                    }
                }
                else
                {

                    var video2 = modal.querySelector('.modal--active .media-with-video__video');
                    video2.play();
                }
            }
        };   
    }
}
